var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { singleton } from "tsyringe";
import { makeImmutable } from "../core";
import { isNRPCError, RestaumaticRPCService } from "./RestaumaticRPCService";
let ReservationService = class ReservationService {
    constructor(rpcService) {
        this.rpcService = rpcService;
        makeImmutable(this);
    }
    async getAvailability(restaurantSlug) {
        return this.rpcService.rpc("GetTableReservationAvailability", {
            restaurantSlug,
        });
    }
    async getTimeSlots(restaurantSlug, date) {
        return this.rpcService.rpc("GetTableReservationTimeSlots", {
            restaurantSlug,
            date,
        });
    }
    async getFormConfig(restaurantSlug) {
        return this.rpcService.rpc("GetReservationFormConfig", { restaurantSlug });
    }
    async createReservation(request) {
        const result = await this.rpcService.rpc2("CreateTableReservation", request);
        if (result === null) {
            return { type: "networkError" };
        }
        // Typed errors come back as an NRPCError `{ error, message, details }`;
        // any other non-null body (Higgs returns the new reservation's id) means success.
        if (!isNRPCError(result)) {
            return { type: "success" };
        }
        switch (result.error) {
            case "RestaurantClosedError":
                return { type: "restaurantClosed" };
            case "ValidationError":
                return { type: "validationError" };
            default:
                return { type: "networkError" };
        }
    }
};
ReservationService = __decorate([
    singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof RestaumaticRPCService !== "undefined" && RestaumaticRPCService) === "function" ? _a : Object])
], ReservationService);
export { ReservationService };
